export const prizeList = [
  {
    icon: require("../assets/img/give_up.png"), // 奖品图片
    name: "再接再厉", // 奖品名称
    isPrize: 0 // 该奖项是否为奖品
  },
  {
    icon: require("../assets/coin/bnb.png"),
    name: "1 BNB",
    isPrize: 1
  },
  {
    icon: require("../assets/coin/eth.png"),
    name: "0.1 ETH",
    isPrize: 1
  },
  {
    icon: require("../assets/coin/wave.png"),
    name: "WAVE",
    isPrize: 1
  },
  {
    icon: require("../assets/coin/usdt.png"),
    name: "10 USDT",
    isPrize: 1
  },
  {
    icon: require("../assets/coin/ltc.png"),
    name: "1 LTC",
    isPrize: 1
  },
  {
    icon: require("../assets/img/give_up.png"),
    name: "再接再厉",
    isPrize: 0
  },
  {
    icon: require("../assets/coin/btc.png"),
    name: "0.01BTC",
    isPrize: 1
  }
]


// WEBPACK FOOTER //
// ./src/components/config.js